import axios from "axios";
import { config_headers, URL_API, servicelist } from "../Config";

export const pAssessmentPrintResult = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.assessmentService}p_assessment_print_result`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};

export const pAssessmentPrintScore = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            await axios.post(URL_API(`${servicelist.assessmentService}p_assessment_print_score`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
